import React from 'react';
type CTAButtonProps = {
  children: React.ReactNode;
  href: string;
  variant?: 'primary' | 'outline';
  className?: string;
};
export function CTAButton({
  children,
  href,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const base = 'inline-flex w-full items-center justify-center rounded-xl px-4 py-3.5 text-center text-[13px] font-extrabold uppercase leading-tight tracking-wide transition-transform duration-150 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900 sm:text-sm';
  const styles = variant === 'primary' ? 'bg-gold-500 text-ink-900 shadow-[0_8px_28px_rgba(232,184,0,0.28)] hover:bg-gold-400' : 'border border-gold-500/60 bg-transparent text-gold-400 hover:border-gold-400 hover:text-gold-300';
  return <a href={href} className={`${base} ${styles} ${className}`} data-id="element-47" data-mp="3cnhvcvvvpuey">
      {children}
    </a>;
}